/**
 * Partner (Element pa-partners): Reihenfolge bei jedem Seitenaufruf mischen, damit kein Partner dauerhaft hinten steht.
 * Im Browser statt am Server, weil die Seite aus dem Seiten-Cache kommt (dort wäre die Reihenfolge eingefroren).
 * Ohne JavaScript bleibt die Reihenfolge aus dem Editor. Die Einblend-Stufe --d wird nach dem Mischen neu vergeben.
 */
import { qsa } from '../utils/dom.js';

export function init() {
	qsa('.pa-partners').forEach((list) => {
		const items = Array.from(list.children);
		if (items.length < 2) return;

		// Fisher-Yates
		for (let i = items.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[items[i], items[j]] = [items[j], items[i]];
		}
		items.forEach((el, i) => {
			if (el.style.getPropertyValue('--d') !== '') el.style.setProperty('--d', String(i));
			list.appendChild(el);
		});
	});
}
